<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">
      @if (type == "Return") {
        Add Return Cash Request
      } @else {
        Add Apply Cash Request
      }
    </h4>
    <button
      type="button"
      class="btn-close"
      data-dismiss="modal"
      tabindex="-1"
      (click)="reset()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="container-fluid p-0">
      @if (type == "Return") {
        <app-asset-return-cash
          [loggedInUser]="loggedInUser"
          [companyCode]="companyCode"
          [companyId]="companyId"
          [defaultFinanceAccount]="defaultFinanceAccount"
        ></app-asset-return-cash>
      } @else {
        <div class="form-floating mb-2">
          <select
            class="browser-default form-select"
            name="applyOption"
            [(ngModel)]="selectedApplyOpt"
            (selectionchange)="resetEverything()"
          >
            @for (o of applyOptions; track o) {
              <option [value]="o">
                {{ o }}
              </option>
            }
          </select>
          <label>Apply Type</label>
        </div>

        @if (
          selectedApplyOpt == "EXPENSES" ||
          selectedApplyOpt == "KERJA" ||
          selectedApplyOpt == "TICKET"
        ) {
          <app-asset-apply-details
            [selectedApplyOpt]="selectedApplyOpt"
            [companyId]="companyId"
            [companyCode]="companyCode"
            [defaultFinanceAccount]="defaultFinanceAccount"
          ></app-asset-apply-details>
        } @else if (selectedApplyOpt == "CONTRA") {
          <app-asset-contra-details
            [selectedApplyOpt]="selectedApplyOpt"
            [companyId]="companyId"
            [companyCode]="companyCode"
            [defaultFinanceAccount]="defaultFinanceAccount"
          ></app-asset-contra-details>
        }
      }
    </div>
  </div>
  <!-- <div class="modal-footer">
        <button class="btn btn-outline-success" type="button" (click)="submit()" [disabled]="disabledSubmit">
            Submit
        </button>
        <button class="btn btn-outline-danger" type="button" (click)="reset()">Cancel</button>
    </div> -->
</form>
